import { Header } from 'widgets';
import { PasswordChangeForm } from 'widgets/password-change-form/ui/password-change-form';
import { PageLayout } from 'shared/ui';

export const PasswordChangePage: React.FC = () => {
  return (
    <PageLayout>
      <Header />
      <PasswordChangeForm />
    </PageLayout>
  );
};
